import { render, staticRenderFns } from "./CategoriesInput.vue?vue&type=template&id=787a96d9"
import script from "./CategoriesInput.vue?vue&type=script&lang=js"
export * from "./CategoriesInput.vue?vue&type=script&lang=js"
import style0 from "./CategoriesInput.vue?vue&type=style&index=0&id=787a96d9&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787a96d9')) {
      api.createRecord('787a96d9', component.options)
    } else {
      api.reload('787a96d9', component.options)
    }
    module.hot.accept("./CategoriesInput.vue?vue&type=template&id=787a96d9", function () {
      api.rerender('787a96d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Place/CategoriesInput.vue"
export default component.exports